// Module
var code = `{{#body}}

<div class="docs-item-block-p">{{.*}}</div>

{{/body}}
`;
// Exports
module.exports = code;